// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.0
// source: data.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "scheduledata";

export enum ImportantDatesLocale {
  IMPORTANT_DATES_LOCALE_UNSPECIFIED = 0,
  IMPORTANT_DATES_LOCALE_EN = 1,
  IMPORTANT_DATES_LOCALE_FR_CA = 2,
  UNRECOGNIZED = -1,
}

export enum ImportantDateEffect {
  IMPORTANT_DATE_EFFECT_UNSPECIFIED = 0,
  IMPORTANT_DATE_EFFECT_STRUCTURAL = 1,
  IMPORTANT_DATE_EFFECT_NO_CLASSES = 2,
  IMPORTANT_DATE_EFFECT_SCHEDULE_REPLACEMENT = 3,
  IMPORTANT_DATE_EFFECT_DEADLINE = 4,
  IMPORTANT_DATE_EFFECT_INFORMATIONAL = 5,
  UNRECOGNIZED = -1,
}

export enum ImportantDateCategory {
  IMPORTANT_DATE_CATEGORY_UNSPECIFIED = 0,
  IMPORTANT_DATE_CATEGORY_OVERVIEW = 1,
  IMPORTANT_DATE_CATEGORY_BREAKS = 2,
  IMPORTANT_DATE_CATEGORY_SCHEDULE_CHANGES = 3,
  IMPORTANT_DATE_CATEGORY_ENROLMENT = 4,
  IMPORTANT_DATE_CATEGORY_GRADES_EXAMS = 5,
  IMPORTANT_DATE_CATEGORY_TUITION = 6,
  IMPORTANT_DATE_CATEGORY_STUDENT_SERVICES = 7,
  IMPORTANT_DATE_CATEGORY_GRADUATE_REPORTS = 8,
  IMPORTANT_DATE_CATEGORY_ACADEMIC_INTEGRITY = 9,
  IMPORTANT_DATE_CATEGORY_PROGRAM_CHANGES = 10,
  IMPORTANT_DATE_CATEGORY_OTHER = 11,
  UNRECOGNIZED = -1,
}

export enum ImportantDateSeason {
  IMPORTANT_DATE_SEASON_UNSPECIFIED = 0,
  IMPORTANT_DATE_SEASON_WINTER = 1,
  IMPORTANT_DATE_SEASON_SPRING_SUMMER = 2,
  IMPORTANT_DATE_SEASON_FALL = 3,
  UNRECOGNIZED = -1,
}

export enum CoursePrereqNodeType {
  COURSE_PREREQ_NODE_TYPE_UNSPECIFIED = 0,
  COURSE_PREREQ_NODE_TYPE_COURSE = 1,
  COURSE_PREREQ_NODE_TYPE_OR_GROUP = 2,
  COURSE_PREREQ_NODE_TYPE_AND_GROUP = 3,
  COURSE_PREREQ_NODE_TYPE_NON_COURSE = 4,
  UNRECOGNIZED = -1,
}

/**
 * Coarse classification of an opaque `non_course` prerequisite (one with no
 * credit pool), so consumers can decide whether it blocks scheduling.
 */
export enum CoursePrereqKind {
  COURSE_PREREQ_KIND_UNSPECIFIED = 0,
  COURSE_PREREQ_KIND_PERMISSION = 1,
  COURSE_PREREQ_KIND_AUDITION = 2,
  COURSE_PREREQ_KIND_LANGUAGE = 3,
  COURSE_PREREQ_KIND_EQUIVALENT = 4,
  COURSE_PREREQ_KIND_HIGHSCHOOL = 5,
  COURSE_PREREQ_KIND_STANDING = 6,
  COURSE_PREREQ_KIND_TOPIC = 7,
  COURSE_PREREQ_KIND_COURSEWORK = 8,
  COURSE_PREREQ_KIND_KNOWLEDGE = 9,
  COURSE_PREREQ_KIND_RECOMMENDED = 10,
  UNRECOGNIZED = -1,
}

export enum RequirementType {
  REQUIREMENT_TYPE_UNSPECIFIED = 0,
  REQUIREMENT_TYPE_COURSE = 1,
  REQUIREMENT_TYPE_ELECTIVE = 2,
  REQUIREMENT_TYPE_GROUP = 3,
  REQUIREMENT_TYPE_PICK = 4,
  REQUIREMENT_TYPE_OPTIONS_GROUP = 5,
  REQUIREMENT_TYPE_DISCIPLINE_ELECTIVE = 6,
  REQUIREMENT_TYPE_FREE_ELECTIVE = 7,
  REQUIREMENT_TYPE_NON_DISCIPLINE_ELECTIVE = 8,
  REQUIREMENT_TYPE_FACULTY_ELECTIVE = 9,
  REQUIREMENT_TYPE_SECTION = 10,
  REQUIREMENT_TYPE_AND = 11,
  REQUIREMENT_TYPE_OR_GROUP = 12,
  REQUIREMENT_TYPE_OR_COURSE = 13,
  UNRECOGNIZED = -1,
}

export enum DayOfWeek {
  DAY_OF_WEEK_UNSPECIFIED = 0,
  DAY_OF_WEEK_MO = 1,
  DAY_OF_WEEK_TU = 2,
  DAY_OF_WEEK_WE = 3,
  DAY_OF_WEEK_TH = 4,
  DAY_OF_WEEK_FR = 5,
  DAY_OF_WEEK_SA = 6,
  DAY_OF_WEEK_SU = 7,
  UNRECOGNIZED = -1,
}

export enum SectionStatus {
  SECTION_STATUS_UNSPECIFIED = 0,
  SECTION_STATUS_OPEN = 1,
  SECTION_STATUS_CLOSED = 2,
  UNRECOGNIZED = -1,
}

export interface CatalogueManifest {
  years: number[];
}

export interface Indices {
  /**
   * Discipline dictionary: distinct course subject prefixes (e.g. "CSI"), in
   * first-occurrence order over `courses`. Doubles as the dictionary for the
   * columnar course encoding and as the state-encoding discipline index space.
   */
  disciplines: string[];
  /**
   * Per-course discipline: index into `disciplines`. The sentinel value
   * `disciplines.length` marks a literal-overflow course (see course_literal_*).
   */
  courseDiscipline: number[];
  /**
   * Per-course catalogue number, delta-encoded (zigzag) within each discipline
   * (course order is append-order, not sorted, so deltas can be negative).
   */
  courseNumberDelta: number[];
  /**
   * Sparse single-letter code suffixes (e.g. "ADM 6385I"): parallel arrays of
   * the course position and the suffix character code.
   */
  courseSuffixPos: number[];
  courseSuffixChar: number[];
  /**
   * Front-coded programs: shared-prefix length with the previous program, plus
   * the remaining suffix (program slugs share long path-like prefixes).
   */
  programPrefixLen: number[];
  programSuffix: string[];
  /**
   * Sparse literal overflow for any course code that doesn't fit the
   * "<DISC> <number><suffix?>" shape (none in current data; forward-compat).
   */
  courseLiteralPos: number[];
  courseLiteral: string[];
}

/**
 * The canonical professor registry: one entry per real person, collapsing the
 * name/diacritic/middle-name variants the same professor accumulates across
 * RateMyProfessors, grades, schedules and feedback. Every other dataset
 * references a professor by his INDEX into `ProfessorsData.professors` rather
 * than repeating a name string. Built by the scraper from the committed
 * `data/professors.json` (see @uoplan/core professorIdentity / the scraper
 * buildRegistry).
 */
export interface ProfessorsData {
  professors: ProfessorEntry[];
}

export interface ProfessorEntry {
  /** Canonical display name: the fullest variant (keeps accents and middle names). */
  name: string;
  /** Every RateMyProfessors legacyId merged into this person (combined reviews). */
  legacyIds: number[];
  /** Response-weighted average rating across all merged RMP profiles, when rated. */
  rating?: number | undefined;
  numRatings?:
    | number
    | undefined;
  /** Other observed spellings of this person's name (for search), excluding `name`. */
  aliases: string[];
}

export interface TermsData {
  terms: Term[];
}

export interface Term {
  termId: number;
  name: string;
}

export interface ImportantDateInterval {
  startYyyymmdd: number;
  endYyyymmdd: number;
  startMinutes?: number | undefined;
  endMinutes?: number | undefined;
}

export interface ScheduleReplacement {
  cancelledYyyymmdd: number;
  replacementYyyymmdd: number;
  sourceDay: DayOfWeek;
}

export interface ImportantDateItem {
  id: string;
  topic: string;
  dateText: string;
  effect: ImportantDateEffect;
  interval?: ImportantDateInterval | undefined;
  replacement?: ScheduleReplacement | undefined;
  usedEnglishFallback?: boolean | undefined;
}

export interface ImportantDateGroup {
  id: string;
  label?: string | undefined;
  items: ImportantDateItem[];
  /**
   * Canonical scoped session code (e.g. "A"), copied verbatim from English to
   * French. Unscoped groups (the general group, "All other sessions…") omit it.
   */
  sessionCode?: string | undefined;
}

export interface ImportantDateSection {
  id: string;
  label: string;
  category: ImportantDateCategory;
  groups: ImportantDateGroup[];
}

/**
 * A named course session (e.g. Spring-Summer sessions "A"/"B"/"C") within a
 * term, exposing the canonical, English-authoritative code and its course
 * date range. See ImportantDateGroup.session_code for the scoped-group link.
 */
export interface ImportantDateSession {
  code: string;
  courseInterval?: ImportantDateInterval | undefined;
}

export interface ImportantDateTerm {
  sourceId: string;
  termId?: number | undefined;
  label: string;
  season: ImportantDateSeason;
  year: number;
  sourcePublished: string;
  termInterval?: ImportantDateInterval | undefined;
  courseInterval?: ImportantDateInterval | undefined;
  sections: ImportantDateSection[];
  sessions: ImportantDateSession[];
}

export interface ImportantDatesData {
  locale: ImportantDatesLocale;
  sourceUrl: string;
  reviewedText?: string | undefined;
  terms: ImportantDateTerm[];
}

export interface RateMyProfessorsData {
  resultCount: number;
  professors: Professor[];
}

export interface Professor {
  legacyId?: number | undefined;
  name: string;
  rating?: number | undefined;
  numRatings?: number | undefined;
}

export interface Faculty {
  name: string;
  nameFr: string;
}

export interface Discipline {
  code: string;
  name: string;
  nameFr: string;
  /** 1-based index into DisciplinesData.faculties; 0/absent = unknown faculty. */
  facultyRef?: number | undefined;
}

export interface DisciplinesData {
  disciplines: Discipline[];
  faculties: Faculty[];
}

export interface Catalogue {
  courseCodes: string[];
  courses: Course[];
  programs: Program[];
  /**
   * Program-requirement code strings not present in `course_codes` (e.g.
   * cross-year references). `ProgramRequirement.code_ref` values past
   * `course_codes.length` index into this list. See ProgramRequirement.
   */
  extraCodes: string[];
}

export interface Course {
  /** 0-based index into `Catalogue.course_codes`. */
  code: number;
  title: string;
  credits: number;
  component?:
    | string
    | undefined;
  /**
   * 0-based indices into `Catalogue.course_codes` (alternate codes for the
   * same course). Packed so the common 0-alias case costs nothing.
   */
  aliases: number[];
  hasPrereqText: boolean;
  prerequisites?: CoursePrereqNode | undefined;
}

export interface CoursePrereqDisciplineLevel {
  discipline: string;
  levels: number[];
}

export interface CoursePrereqNode {
  type: CoursePrereqNodeType;
  code?: string | undefined;
  credits?: number | undefined;
  disciplines: string[];
  levels: number[];
  disciplineLevels: CoursePrereqDisciplineLevel[];
  programs: string[];
  children: CoursePrereqNode[];
  text?: string | undefined;
  kind?: CoursePrereqKind | undefined;
}

/**
 * Per-course prerequisite history. The union `Catalogue` carries each course's
 * LATEST prerequisites; this overlay reconstructs earlier cohorts' prerequisites
 * (and powers a per-course prereq changelog) without shipping a full catalogue
 * per year. Only prerequisites are tracked — credits/title/component drift is
 * negligible or non-cohort-critical, so consumers use the latest values for
 * those. See @uoplan/core reconstructCatalogueForYear.
 */
export interface CataloguePrereqHistory {
  /**
   * Catalogue years this overlay is defined against, sorted ascending. Bit `i`
   * of every `PrereqRevision.year_mask` corresponds to `years[i]`. The newest
   * year is the baseline (its prerequisites live in the union Catalogue) and is
   * never referenced by a revision.
   */
  years: number[];
  overlays: CoursePrereqOverlay[];
}

export interface CoursePrereqOverlay {
  /** 0-based index into the union `Catalogue.course_codes`. */
  code: number;
  /**
   * Distinct prerequisite values this course had in non-latest years, each with
   * the set of years it applied to. A course with stable prerequisites has no
   * overlay entry at all.
   */
  revisions: PrereqRevision[];
}

export interface PrereqRevision {
  /** Bitmask over `CataloguePrereqHistory.years`: which years used this value. */
  yearMask: number;
  /** Prerequisites for those years; absent = the course had no prerequisites then. */
  prerequisites?:
    | CoursePrereqNode
    | undefined;
  /** Mirror of `Course.has_prereq_text` for those years. */
  hasPrereqText: boolean;
}

/**
 * Per-cohort program history. The union `Catalogue` carries the LATEST year's
 * programs; this overlay reconstructs earlier cohorts' program lists without
 * shipping a full programs-only catalogue per year (each of which duplicated a
 * ~thousand-entry course-code dictionary). Program-requirement `code_ref`
 * values in this overlay index the UNION `Catalogue.course_codes` (plus this
 * overlay's `extra_codes` for the few program-only codes absent from the
 * union), exactly like `Catalogue.code_ref`. See @uoplan/core
 * reconstructProgramsForYear.
 */
export interface CatalogueProgramHistory {
  /**
   * Catalogue years this overlay is defined against, sorted ascending. Bit `i`
   * of every mask corresponds to `years[i]`. The newest year is the baseline
   * (its programs live in the union Catalogue).
   */
  years: number[];
  overlays: ProgramOverlay[];
  /**
   * Program-requirement code strings not present in the union
   * `Catalogue.course_codes`. A `ProgramRequirement.code_ref` value past
   * `union.course_codes.length` indexes this list (`ref - union_len - 1`),
   * mirroring `Catalogue.extra_codes`.
   */
  extraCodes: string[];
}

/**
 * One program key's cross-cohort presence + value history. A program that was
 * present in EVERY tracked year with the union (latest) value has no overlay at
 * all (it is reconstructed from the union baseline for every year).
 */
export interface ProgramOverlay {
  /**
   * Program identity, matching `Program.program_key`. May be absent from the
   * union's latest programs (a history-only program dropped before latest), in
   * which case `baseline_present_mask` is 0 and all presence lives in
   * `revisions`.
   */
  programKey: string;
  /**
   * Bitmask over `years`: years the program was present with a value EQUAL to
   * the union baseline (so its value is not restated here). 0 for history-only
   * programs (no union baseline exists to equal).
   */
  baselinePresentMask: number;
  /**
   * Distinct non-baseline program values, each with the set of years that used
   * it. A program present in a year is covered by exactly one of these
   * revisions or by `baseline_present_mask`; absence in a year means neither.
   */
  revisions: ProgramRevision[];
}

export interface ProgramRevision {
  /** Bitmask over `CatalogueProgramHistory.years`: which years used this value. */
  yearMask: number;
  /** The full program (title + requirements) for those years. */
  program?: Program | undefined;
}

/**
 * Compact keyword index over course descriptions, enabling a secondary
 * "matched in description" search signal without ever shipping the raw
 * description text (~1 MB gzipped). Ships a front-coded keyword dictionary +
 * per-course term frequencies — enough for BM25 scoring with exact, prefix
 * (search-as-you-type), and edit-distance fuzzy matching. See
 * docs/explore-search.md.
 */
export interface CourseSearchIndex {
  /**
   * Normalized course codes covered by the index (only courses whose description
   * is distinct from their title), sorted ascending for gzip locality. A posting
   * references a course by its index in this list.
   */
  courseCodes: string[];
  /**
   * BM25 document length per course, parallel to `course_codes`: the number of
   * kept keyword occurrences in that course's description.
   */
  docLengths: number[];
  /**
   * Sorted keyword dictionary, front-coded to collapse the shared prefixes of
   * adjacent sorted terms. Concatenated entries, one per term (a term's id is its
   * position): varint prefix_len (bytes shared with the previous term) + varint
   * suffix_len (bytes) + suffix (UTF-8, ASCII in practice). Terms are the folded/
   * stemmed keyword tokens, so a query token is matched by exact binary search,
   * prefix range scan, or bounded edit-distance scan over this list.
   */
  termDictionary: Uint8Array;
  /**
   * Document frequency (posting count) per dictionary term, parallel to the
   * dictionary order. Its sum equals the length of `posting_course_deltas` /
   * `posting_freqs`.
   */
  termDfs: number[];
  /**
   * Flattened postings for every dictionary term, concatenated in dictionary
   * order (flat arrays avoid per-term message framing). For term `t`, the next
   * `term_dfs[t]` entries are its postings: `posting_course_deltas` holds the
   * ascending course indices delta-encoded *within* the term (the running course
   * index resets to 0 at each term boundary); `posting_freqs` holds the parallel
   * term frequencies (clamped small).
   */
  postingCourseDeltas: number[];
  postingFreqs: number[];
}

export interface CourseDescriptionShard {
  courseCodes: string[];
  descriptions: string[];
}

export interface DisciplineLevel {
  discipline: string;
  levels: number[];
}

export interface ProgramRequirement {
  type: RequirementType;
  title?: string | undefined;
  disciplineLevels: DisciplineLevel[];
  excludedDisciplines: string[];
  faculty?: string | undefined;
  indented?: boolean | undefined;
  options: ProgramRequirement[];
  levels: number[];
  /**
   * 1-based reference to a course code. 0 = absent. Values in
   * 1..=Catalogue.course_codes.length index `course_codes` (ref-1, 0-based);
   * larger values index `Catalogue.extra_codes` (ref - course_codes.length - 1).
   */
  codeRef?:
    | number
    | undefined;
  /**
   * Credits scaled ×4 (all catalogue credits are exact quarter-multiples).
   * Decoded as credits_x4 / 4.
   */
  creditsX4?: number | undefined;
}

export interface Program {
  title: string;
  programKey: string;
  requirements: ProgramRequirement[];
}

export interface MeetingTime {
  day: DayOfWeek;
  startMinutes: number;
  endMinutes: number;
  virtual: boolean;
  instructor?:
    | string
    | undefined;
  /**
   * 1-based index into `ProfessorsData.professors`; absent when unassigned
   * ("Staff") or unresolved. 1-based so a present value is never the default 0.
   */
  professorRef?:
    | number
    | undefined;
  /**
   * 1-based index into `SchedulesData.meeting_date_ranges`; absent/0 when the
   * meeting has no known date range.
   */
  meetingDatesRef?: number | undefined;
}

export interface MeetingDateRange {
  startYyyymmdd: number;
  endYyyymmdd: number;
}

/**
 * A build-time guess of who may teach a section that has no assigned
 * instructor (every meeting time is "Staff"/blank). Informational only: these
 * names are NEVER fed into grade lookups, professor-rating filters, or the
 * schedule-generation engine.
 */
export interface PredictedInstructor {
  name: string;
  /**
   * RateMyProfessors legacy id, resolved from grades.json when the name can be
   * matched. Absent for schedule-only candidates with no grades record.
   */
  legacyId?:
    | number
    | undefined;
  /** 1-based index into `ProfessorsData.professors` (0 = unresolved). */
  professorRef?: number | undefined;
}

export interface ComponentSection {
  section: string;
  sectionCode?: string | undefined;
  component?: string | undefined;
  session?: string | undefined;
  times: MeetingTime[];
  /** fields 6 and 7 reserved (instructors/meeting_dates moved into MeetingTime) */
  status: SectionStatus;
  /**
   * Populated ONLY when the section has no known instructor; the build-time
   * guess of who may teach it. Empty for sections with an assigned instructor.
   */
  predictedInstructors: PredictedInstructor[];
}

export interface ComponentSectionList {
  items: ComponentSection[];
}

export interface CourseSchedule {
  /** 0-based index into `SchedulesData.course_codes`. */
  course: number;
  title?: string | undefined;
  timeZone: string;
  components: { [key: string]: ComponentSectionList };
}

export interface CourseSchedule_ComponentsEntry {
  key: string;
  value?: ComponentSectionList | undefined;
}

export interface SchedulesData {
  termId: number;
  courseCodes: string[];
  totalCourses?: number | undefined;
  totalWithSchedules?: number | undefined;
  schedules: CourseSchedule[];
  /**
   * Dictionary of distinct meeting date ranges for this term, referenced
   * (1-based) by `MeetingTime.meeting_dates_ref`. Most meetings of a term share
   * a handful of ranges, so this avoids a per-meeting MeetingDateRange submessage.
   */
  meetingDateRanges: MeetingDateRange[];
}

/**
 * Grade data is stored column-wise per course: every `repeated` field below is a
 * parallel array where index `i` describes one (section/professor, term, section)
 * offering of the course. This avoids a per-offering submessage and a per-cell
 * field tag, and lets the optional section professor name be shared via a dictionary.
 */
export interface GradesData {
  courses: CourseGradeEntry[];
  /**
   * Dictionary of distinct offering section/professor display names, referenced 0-based
   * by `CourseGradeEntry.name_refs`. The same professor appears across many
   * offerings, so the names are deduplicated here.
   */
  sectionNames: string[];
}

/**
 * One course's grade offerings, stored as parallel columns. All `repeated`
 * fields have the same length N (the number of offerings); index `i` is one
 * offering. `distributions` is the only exception: it is N*18 values, row-major,
 * so offering `i` occupies `distributions[i*18 .. i*18+18]`.
 */
export interface CourseGradeEntry {
  code: string;
  /** 0-based index into `GradesData.section_names`. */
  nameRefs: number[];
  termIds: number[];
  /** 1-based index into `ProfessorsData.professors` (0 = unresolved). */
  professorRefs: number[];
  /** RateMyProfessors legacy id (0 = none). */
  legacyIds: number[];
  /** Per-offering section code ("" = none). */
  sections: string[];
  /**
   * N*18 grade counts, row-major, in the canonical letter order:
   * A+, A, A-, B+, B, C+, C, D+, D, E, F, DR, EIN, NS, NC, ABS, P, S.
   */
  distributions: number[];
}

function createBaseCatalogueManifest(): CatalogueManifest {
  return { years: [] };
}

export const CatalogueManifest: MessageFns<CatalogueManifest> = {
  encode(message: CatalogueManifest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.years) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogueManifest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogueManifest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.years.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.years.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseIndices(): Indices {
  return {
    disciplines: [],
    courseDiscipline: [],
    courseNumberDelta: [],
    courseSuffixPos: [],
    courseSuffixChar: [],
    programPrefixLen: [],
    programSuffix: [],
    courseLiteralPos: [],
    courseLiteral: [],
  };
}

export const Indices: MessageFns<Indices> = {
  encode(message: Indices, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.disciplines) {
      writer.uint32(26).string(v!);
    }
    writer.uint32(34).fork();
    for (const v of message.courseDiscipline) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.courseNumberDelta) {
      writer.sint32(v);
    }
    writer.join();
    writer.uint32(50).fork();
    for (const v of message.courseSuffixPos) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(58).fork();
    for (const v of message.courseSuffixChar) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(66).fork();
    for (const v of message.programPrefixLen) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.programSuffix) {
      writer.uint32(74).string(v!);
    }
    writer.uint32(82).fork();
    for (const v of message.courseLiteralPos) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.courseLiteral) {
      writer.uint32(90).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Indices {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndices();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.disciplines.push(reader.string());
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.courseDiscipline.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseDiscipline.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 40) {
            message.courseNumberDelta.push(reader.sint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseNumberDelta.push(reader.sint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag === 48) {
            message.courseSuffixPos.push(reader.uint32());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseSuffixPos.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 7: {
          if (tag === 56) {
            message.courseSuffixChar.push(reader.uint32());

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseSuffixChar.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag === 64) {
            message.programPrefixLen.push(reader.uint32());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.programPrefixLen.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.programSuffix.push(reader.string());
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.courseLiteralPos.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseLiteralPos.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.courseLiteral.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProfessorsData(): ProfessorsData {
  return { professors: [] };
}

export const ProfessorsData: MessageFns<ProfessorsData> = {
  encode(message: ProfessorsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.professors) {
      ProfessorEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProfessorsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProfessorsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.professors.push(ProfessorEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProfessorEntry(): ProfessorEntry {
  return { name: "", legacyIds: [], rating: undefined, numRatings: undefined, aliases: [] };
}

export const ProfessorEntry: MessageFns<ProfessorEntry> = {
  encode(message: ProfessorEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    writer.uint32(26).fork();
    for (const v of message.legacyIds) {
      writer.uint32(v);
    }
    writer.join();
    if (message.rating !== undefined) {
      writer.uint32(33).double(message.rating);
    }
    if (message.numRatings !== undefined) {
      writer.uint32(40).uint32(message.numRatings);
    }
    for (const v of message.aliases) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProfessorEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProfessorEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.legacyIds.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.legacyIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.rating = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.numRatings = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.aliases.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseTermsData(): TermsData {
  return { terms: [] };
}

export const TermsData: MessageFns<TermsData> = {
  encode(message: TermsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.terms) {
      Term.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TermsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTermsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.terms.push(Term.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseTerm(): Term {
  return { termId: 0, name: "" };
}

export const Term: MessageFns<Term> = {
  encode(message: Term, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.termId !== 0) {
      writer.uint32(8).uint32(message.termId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Term {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTerm();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.termId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateInterval(): ImportantDateInterval {
  return { startYyyymmdd: 0, endYyyymmdd: 0, startMinutes: undefined, endMinutes: undefined };
}

export const ImportantDateInterval: MessageFns<ImportantDateInterval> = {
  encode(message: ImportantDateInterval, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startYyyymmdd !== 0) {
      writer.uint32(8).uint32(message.startYyyymmdd);
    }
    if (message.endYyyymmdd !== 0) {
      writer.uint32(16).uint32(message.endYyyymmdd);
    }
    if (message.startMinutes !== undefined) {
      writer.uint32(24).uint32(message.startMinutes);
    }
    if (message.endMinutes !== undefined) {
      writer.uint32(32).uint32(message.endMinutes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateInterval {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateInterval();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startYyyymmdd = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endYyyymmdd = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.startMinutes = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.endMinutes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseScheduleReplacement(): ScheduleReplacement {
  return { cancelledYyyymmdd: 0, replacementYyyymmdd: 0, sourceDay: 0 };
}

export const ScheduleReplacement: MessageFns<ScheduleReplacement> = {
  encode(message: ScheduleReplacement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cancelledYyyymmdd !== 0) {
      writer.uint32(8).uint32(message.cancelledYyyymmdd);
    }
    if (message.replacementYyyymmdd !== 0) {
      writer.uint32(16).uint32(message.replacementYyyymmdd);
    }
    if (message.sourceDay !== 0) {
      writer.uint32(24).int32(message.sourceDay);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleReplacement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduleReplacement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cancelledYyyymmdd = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.replacementYyyymmdd = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.sourceDay = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateItem(): ImportantDateItem {
  return {
    id: "",
    topic: "",
    dateText: "",
    effect: 0,
    interval: undefined,
    replacement: undefined,
    usedEnglishFallback: undefined,
  };
}

export const ImportantDateItem: MessageFns<ImportantDateItem> = {
  encode(message: ImportantDateItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.topic !== "") {
      writer.uint32(18).string(message.topic);
    }
    if (message.dateText !== "") {
      writer.uint32(26).string(message.dateText);
    }
    if (message.effect !== 0) {
      writer.uint32(32).int32(message.effect);
    }
    if (message.interval !== undefined) {
      ImportantDateInterval.encode(message.interval, writer.uint32(42).fork()).join();
    }
    if (message.replacement !== undefined) {
      ScheduleReplacement.encode(message.replacement, writer.uint32(50).fork()).join();
    }
    if (message.usedEnglishFallback !== undefined) {
      writer.uint32(56).bool(message.usedEnglishFallback);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.topic = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dateText = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.effect = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.interval = ImportantDateInterval.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.replacement = ScheduleReplacement.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.usedEnglishFallback = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateGroup(): ImportantDateGroup {
  return { id: "", label: undefined, items: [], sessionCode: undefined };
}

export const ImportantDateGroup: MessageFns<ImportantDateGroup> = {
  encode(message: ImportantDateGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== undefined) {
      writer.uint32(18).string(message.label);
    }
    for (const v of message.items) {
      ImportantDateItem.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.sessionCode !== undefined) {
      writer.uint32(34).string(message.sessionCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.items.push(ImportantDateItem.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sessionCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateSection(): ImportantDateSection {
  return { id: "", label: "", category: 0, groups: [] };
}

export const ImportantDateSection: MessageFns<ImportantDateSection> = {
  encode(message: ImportantDateSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    for (const v of message.groups) {
      ImportantDateGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.groups.push(ImportantDateGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateSession(): ImportantDateSession {
  return { code: "", courseInterval: undefined };
}

export const ImportantDateSession: MessageFns<ImportantDateSession> = {
  encode(message: ImportantDateSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.courseInterval !== undefined) {
      ImportantDateInterval.encode(message.courseInterval, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.courseInterval = ImportantDateInterval.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDateTerm(): ImportantDateTerm {
  return {
    sourceId: "",
    termId: undefined,
    label: "",
    season: 0,
    year: 0,
    sourcePublished: "",
    termInterval: undefined,
    courseInterval: undefined,
    sections: [],
    sessions: [],
  };
}

export const ImportantDateTerm: MessageFns<ImportantDateTerm> = {
  encode(message: ImportantDateTerm, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceId !== "") {
      writer.uint32(10).string(message.sourceId);
    }
    if (message.termId !== undefined) {
      writer.uint32(16).uint32(message.termId);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    if (message.season !== 0) {
      writer.uint32(32).int32(message.season);
    }
    if (message.year !== 0) {
      writer.uint32(40).uint32(message.year);
    }
    if (message.sourcePublished !== "") {
      writer.uint32(50).string(message.sourcePublished);
    }
    if (message.termInterval !== undefined) {
      ImportantDateInterval.encode(message.termInterval, writer.uint32(58).fork()).join();
    }
    if (message.courseInterval !== undefined) {
      ImportantDateInterval.encode(message.courseInterval, writer.uint32(66).fork()).join();
    }
    for (const v of message.sections) {
      ImportantDateSection.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.sessions) {
      ImportantDateSession.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDateTerm {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDateTerm();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sourceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.termId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.season = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.year = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sourcePublished = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.termInterval = ImportantDateInterval.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.courseInterval = ImportantDateInterval.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sections.push(ImportantDateSection.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.sessions.push(ImportantDateSession.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseImportantDatesData(): ImportantDatesData {
  return { locale: 0, sourceUrl: "", reviewedText: undefined, terms: [] };
}

export const ImportantDatesData: MessageFns<ImportantDatesData> = {
  encode(message: ImportantDatesData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.locale !== 0) {
      writer.uint32(8).int32(message.locale);
    }
    if (message.sourceUrl !== "") {
      writer.uint32(18).string(message.sourceUrl);
    }
    if (message.reviewedText !== undefined) {
      writer.uint32(26).string(message.reviewedText);
    }
    for (const v of message.terms) {
      ImportantDateTerm.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImportantDatesData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImportantDatesData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.locale = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sourceUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reviewedText = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.terms.push(ImportantDateTerm.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseRateMyProfessorsData(): RateMyProfessorsData {
  return { resultCount: 0, professors: [] };
}

export const RateMyProfessorsData: MessageFns<RateMyProfessorsData> = {
  encode(message: RateMyProfessorsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.resultCount !== 0) {
      writer.uint32(8).uint32(message.resultCount);
    }
    for (const v of message.professors) {
      Professor.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RateMyProfessorsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRateMyProfessorsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.resultCount = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.professors.push(Professor.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProfessor(): Professor {
  return { legacyId: undefined, name: "", rating: undefined, numRatings: undefined };
}

export const Professor: MessageFns<Professor> = {
  encode(message: Professor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.legacyId !== undefined) {
      writer.uint32(16).uint32(message.legacyId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.rating !== undefined) {
      writer.uint32(33).double(message.rating);
    }
    if (message.numRatings !== undefined) {
      writer.uint32(40).uint32(message.numRatings);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Professor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProfessor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.legacyId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.rating = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.numRatings = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseFaculty(): Faculty {
  return { name: "", nameFr: "" };
}

export const Faculty: MessageFns<Faculty> = {
  encode(message: Faculty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.nameFr !== "") {
      writer.uint32(26).string(message.nameFr);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Faculty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFaculty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nameFr = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseDiscipline(): Discipline {
  return { code: "", name: "", nameFr: "", facultyRef: undefined };
}

export const Discipline: MessageFns<Discipline> = {
  encode(message: Discipline, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.nameFr !== "") {
      writer.uint32(26).string(message.nameFr);
    }
    if (message.facultyRef !== undefined) {
      writer.uint32(32).uint32(message.facultyRef);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Discipline {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscipline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nameFr = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.facultyRef = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseDisciplinesData(): DisciplinesData {
  return { disciplines: [], faculties: [] };
}

export const DisciplinesData: MessageFns<DisciplinesData> = {
  encode(message: DisciplinesData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.disciplines) {
      Discipline.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.faculties) {
      Faculty.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisciplinesData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisciplinesData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.disciplines.push(Discipline.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.faculties.push(Faculty.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCatalogue(): Catalogue {
  return { courseCodes: [], courses: [], programs: [], extraCodes: [] };
}

export const Catalogue: MessageFns<Catalogue> = {
  encode(message: Catalogue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.courseCodes) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.courses) {
      Course.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.programs) {
      Program.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.extraCodes) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Catalogue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.courseCodes.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.courses.push(Course.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.programs.push(Program.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.extraCodes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourse(): Course {
  return {
    code: 0,
    title: "",
    credits: 0,
    component: undefined,
    aliases: [],
    hasPrereqText: false,
    prerequisites: undefined,
  };
}

export const Course: MessageFns<Course> = {
  encode(message: Course, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).uint32(message.code);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.credits !== 0) {
      writer.uint32(25).double(message.credits);
    }
    if (message.component !== undefined) {
      writer.uint32(34).string(message.component);
    }
    writer.uint32(42).fork();
    for (const v of message.aliases) {
      writer.uint32(v);
    }
    writer.join();
    if (message.hasPrereqText !== false) {
      writer.uint32(48).bool(message.hasPrereqText);
    }
    if (message.prerequisites !== undefined) {
      CoursePrereqNode.encode(message.prerequisites, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Course {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.credits = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.component = reader.string();
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.aliases.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.aliases.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.hasPrereqText = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.prerequisites = CoursePrereqNode.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCoursePrereqDisciplineLevel(): CoursePrereqDisciplineLevel {
  return { discipline: "", levels: [] };
}

export const CoursePrereqDisciplineLevel: MessageFns<CoursePrereqDisciplineLevel> = {
  encode(message: CoursePrereqDisciplineLevel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.discipline !== "") {
      writer.uint32(10).string(message.discipline);
    }
    writer.uint32(18).fork();
    for (const v of message.levels) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoursePrereqDisciplineLevel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoursePrereqDisciplineLevel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.discipline = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.levels.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levels.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCoursePrereqNode(): CoursePrereqNode {
  return {
    type: 0,
    code: undefined,
    credits: undefined,
    disciplines: [],
    levels: [],
    disciplineLevels: [],
    programs: [],
    children: [],
    text: undefined,
    kind: undefined,
  };
}

export const CoursePrereqNode: MessageFns<CoursePrereqNode> = {
  encode(message: CoursePrereqNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.code !== undefined) {
      writer.uint32(18).string(message.code);
    }
    if (message.credits !== undefined) {
      writer.uint32(25).double(message.credits);
    }
    for (const v of message.disciplines) {
      writer.uint32(34).string(v!);
    }
    writer.uint32(42).fork();
    for (const v of message.levels) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.disciplineLevels) {
      CoursePrereqDisciplineLevel.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.programs) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.children) {
      CoursePrereqNode.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.text !== undefined) {
      writer.uint32(74).string(message.text);
    }
    if (message.kind !== undefined) {
      writer.uint32(80).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoursePrereqNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoursePrereqNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.credits = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.disciplines.push(reader.string());
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.levels.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levels.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.disciplineLevels.push(CoursePrereqDisciplineLevel.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.programs.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.children.push(CoursePrereqNode.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCataloguePrereqHistory(): CataloguePrereqHistory {
  return { years: [], overlays: [] };
}

export const CataloguePrereqHistory: MessageFns<CataloguePrereqHistory> = {
  encode(message: CataloguePrereqHistory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.years) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.overlays) {
      CoursePrereqOverlay.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CataloguePrereqHistory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCataloguePrereqHistory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.years.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.years.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.overlays.push(CoursePrereqOverlay.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCoursePrereqOverlay(): CoursePrereqOverlay {
  return { code: 0, revisions: [] };
}

export const CoursePrereqOverlay: MessageFns<CoursePrereqOverlay> = {
  encode(message: CoursePrereqOverlay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).uint32(message.code);
    }
    for (const v of message.revisions) {
      PrereqRevision.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CoursePrereqOverlay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoursePrereqOverlay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.revisions.push(PrereqRevision.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBasePrereqRevision(): PrereqRevision {
  return { yearMask: 0, prerequisites: undefined, hasPrereqText: false };
}

export const PrereqRevision: MessageFns<PrereqRevision> = {
  encode(message: PrereqRevision, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.yearMask !== 0) {
      writer.uint32(8).uint32(message.yearMask);
    }
    if (message.prerequisites !== undefined) {
      CoursePrereqNode.encode(message.prerequisites, writer.uint32(18).fork()).join();
    }
    if (message.hasPrereqText !== false) {
      writer.uint32(24).bool(message.hasPrereqText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrereqRevision {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrereqRevision();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.yearMask = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.prerequisites = CoursePrereqNode.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.hasPrereqText = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCatalogueProgramHistory(): CatalogueProgramHistory {
  return { years: [], overlays: [], extraCodes: [] };
}

export const CatalogueProgramHistory: MessageFns<CatalogueProgramHistory> = {
  encode(message: CatalogueProgramHistory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.years) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.overlays) {
      ProgramOverlay.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.extraCodes) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogueProgramHistory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogueProgramHistory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.years.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.years.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.overlays.push(ProgramOverlay.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.extraCodes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProgramOverlay(): ProgramOverlay {
  return { programKey: "", baselinePresentMask: 0, revisions: [] };
}

export const ProgramOverlay: MessageFns<ProgramOverlay> = {
  encode(message: ProgramOverlay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.programKey !== "") {
      writer.uint32(10).string(message.programKey);
    }
    if (message.baselinePresentMask !== 0) {
      writer.uint32(16).uint32(message.baselinePresentMask);
    }
    for (const v of message.revisions) {
      ProgramRevision.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProgramOverlay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProgramOverlay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.programKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.baselinePresentMask = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.revisions.push(ProgramRevision.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProgramRevision(): ProgramRevision {
  return { yearMask: 0, program: undefined };
}

export const ProgramRevision: MessageFns<ProgramRevision> = {
  encode(message: ProgramRevision, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.yearMask !== 0) {
      writer.uint32(8).uint32(message.yearMask);
    }
    if (message.program !== undefined) {
      Program.encode(message.program, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProgramRevision {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProgramRevision();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.yearMask = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.program = Program.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourseSearchIndex(): CourseSearchIndex {
  return {
    courseCodes: [],
    docLengths: [],
    termDictionary: new Uint8Array(0),
    termDfs: [],
    postingCourseDeltas: [],
    postingFreqs: [],
  };
}

export const CourseSearchIndex: MessageFns<CourseSearchIndex> = {
  encode(message: CourseSearchIndex, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.courseCodes) {
      writer.uint32(10).string(v!);
    }
    writer.uint32(18).fork();
    for (const v of message.docLengths) {
      writer.uint32(v);
    }
    writer.join();
    if (message.termDictionary.length !== 0) {
      writer.uint32(26).bytes(message.termDictionary);
    }
    writer.uint32(34).fork();
    for (const v of message.termDfs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.postingCourseDeltas) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(50).fork();
    for (const v of message.postingFreqs) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CourseSearchIndex {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourseSearchIndex();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.courseCodes.push(reader.string());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.docLengths.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.docLengths.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.termDictionary = reader.bytes();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.termDfs.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.termDfs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 40) {
            message.postingCourseDeltas.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.postingCourseDeltas.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag === 48) {
            message.postingFreqs.push(reader.uint32());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.postingFreqs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourseDescriptionShard(): CourseDescriptionShard {
  return { courseCodes: [], descriptions: [] };
}

export const CourseDescriptionShard: MessageFns<CourseDescriptionShard> = {
  encode(message: CourseDescriptionShard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.courseCodes) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.descriptions) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CourseDescriptionShard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourseDescriptionShard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.courseCodes.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.descriptions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseDisciplineLevel(): DisciplineLevel {
  return { discipline: "", levels: [] };
}

export const DisciplineLevel: MessageFns<DisciplineLevel> = {
  encode(message: DisciplineLevel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.discipline !== "") {
      writer.uint32(10).string(message.discipline);
    }
    writer.uint32(18).fork();
    for (const v of message.levels) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisciplineLevel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisciplineLevel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.discipline = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.levels.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levels.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProgramRequirement(): ProgramRequirement {
  return {
    type: 0,
    title: undefined,
    disciplineLevels: [],
    excludedDisciplines: [],
    faculty: undefined,
    indented: undefined,
    options: [],
    levels: [],
    codeRef: undefined,
    creditsX4: undefined,
  };
}

export const ProgramRequirement: MessageFns<ProgramRequirement> = {
  encode(message: ProgramRequirement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.title !== undefined) {
      writer.uint32(18).string(message.title);
    }
    for (const v of message.disciplineLevels) {
      DisciplineLevel.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.excludedDisciplines) {
      writer.uint32(50).string(v!);
    }
    if (message.faculty !== undefined) {
      writer.uint32(58).string(message.faculty);
    }
    if (message.indented !== undefined) {
      writer.uint32(64).bool(message.indented);
    }
    for (const v of message.options) {
      ProgramRequirement.encode(v!, writer.uint32(74).fork()).join();
    }
    writer.uint32(82).fork();
    for (const v of message.levels) {
      writer.uint32(v);
    }
    writer.join();
    if (message.codeRef !== undefined) {
      writer.uint32(88).uint32(message.codeRef);
    }
    if (message.creditsX4 !== undefined) {
      writer.uint32(96).uint32(message.creditsX4);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProgramRequirement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProgramRequirement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.disciplineLevels.push(DisciplineLevel.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.excludedDisciplines.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.faculty = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.indented = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.options.push(ProgramRequirement.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.levels.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levels.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.codeRef = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.creditsX4 = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseProgram(): Program {
  return { title: "", programKey: "", requirements: [] };
}

export const Program: MessageFns<Program> = {
  encode(message: Program, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.programKey !== "") {
      writer.uint32(18).string(message.programKey);
    }
    for (const v of message.requirements) {
      ProgramRequirement.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Program {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProgram();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.programKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requirements.push(ProgramRequirement.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseMeetingTime(): MeetingTime {
  return {
    day: 0,
    startMinutes: 0,
    endMinutes: 0,
    virtual: false,
    instructor: undefined,
    professorRef: undefined,
    meetingDatesRef: undefined,
  };
}

export const MeetingTime: MessageFns<MeetingTime> = {
  encode(message: MeetingTime, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.day !== 0) {
      writer.uint32(8).int32(message.day);
    }
    if (message.startMinutes !== 0) {
      writer.uint32(16).uint32(message.startMinutes);
    }
    if (message.endMinutes !== 0) {
      writer.uint32(24).uint32(message.endMinutes);
    }
    if (message.virtual !== false) {
      writer.uint32(32).bool(message.virtual);
    }
    if (message.instructor !== undefined) {
      writer.uint32(42).string(message.instructor);
    }
    if (message.professorRef !== undefined) {
      writer.uint32(56).uint32(message.professorRef);
    }
    if (message.meetingDatesRef !== undefined) {
      writer.uint32(64).uint32(message.meetingDatesRef);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingTime {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.day = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.startMinutes = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.endMinutes = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.virtual = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.instructor = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.professorRef = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.meetingDatesRef = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseMeetingDateRange(): MeetingDateRange {
  return { startYyyymmdd: 0, endYyyymmdd: 0 };
}

export const MeetingDateRange: MessageFns<MeetingDateRange> = {
  encode(message: MeetingDateRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startYyyymmdd !== 0) {
      writer.uint32(8).uint32(message.startYyyymmdd);
    }
    if (message.endYyyymmdd !== 0) {
      writer.uint32(16).uint32(message.endYyyymmdd);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingDateRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingDateRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startYyyymmdd = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endYyyymmdd = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBasePredictedInstructor(): PredictedInstructor {
  return { name: "", legacyId: undefined, professorRef: undefined };
}

export const PredictedInstructor: MessageFns<PredictedInstructor> = {
  encode(message: PredictedInstructor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.legacyId !== undefined) {
      writer.uint32(16).uint32(message.legacyId);
    }
    if (message.professorRef !== undefined) {
      writer.uint32(24).uint32(message.professorRef);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PredictedInstructor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePredictedInstructor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.legacyId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.professorRef = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseComponentSection(): ComponentSection {
  return {
    section: "",
    sectionCode: undefined,
    component: undefined,
    session: undefined,
    times: [],
    status: 0,
    predictedInstructors: [],
  };
}

export const ComponentSection: MessageFns<ComponentSection> = {
  encode(message: ComponentSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.section !== "") {
      writer.uint32(10).string(message.section);
    }
    if (message.sectionCode !== undefined) {
      writer.uint32(18).string(message.sectionCode);
    }
    if (message.component !== undefined) {
      writer.uint32(26).string(message.component);
    }
    if (message.session !== undefined) {
      writer.uint32(34).string(message.session);
    }
    for (const v of message.times) {
      MeetingTime.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(64).int32(message.status);
    }
    for (const v of message.predictedInstructors) {
      PredictedInstructor.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComponentSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.section = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sectionCode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.component = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.session = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.times.push(MeetingTime.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.predictedInstructors.push(PredictedInstructor.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseComponentSectionList(): ComponentSectionList {
  return { items: [] };
}

export const ComponentSectionList: MessageFns<ComponentSectionList> = {
  encode(message: ComponentSectionList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      ComponentSection.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComponentSectionList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComponentSectionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(ComponentSection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourseSchedule(): CourseSchedule {
  return { course: 0, title: undefined, timeZone: "", components: {} };
}

export const CourseSchedule: MessageFns<CourseSchedule> = {
  encode(message: CourseSchedule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.course !== 0) {
      writer.uint32(8).uint32(message.course);
    }
    if (message.title !== undefined) {
      writer.uint32(18).string(message.title);
    }
    if (message.timeZone !== "") {
      writer.uint32(26).string(message.timeZone);
    }
    globalThis.Object.entries(message.components).forEach(([key, value]: [string, ComponentSectionList]) => {
      CourseSchedule_ComponentsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CourseSchedule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourseSchedule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.course = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timeZone = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = CourseSchedule_ComponentsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.components[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourseSchedule_ComponentsEntry(): CourseSchedule_ComponentsEntry {
  return { key: "", value: undefined };
}

export const CourseSchedule_ComponentsEntry: MessageFns<CourseSchedule_ComponentsEntry> = {
  encode(message: CourseSchedule_ComponentsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ComponentSectionList.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CourseSchedule_ComponentsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourseSchedule_ComponentsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = ComponentSectionList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseSchedulesData(): SchedulesData {
  return {
    termId: 0,
    courseCodes: [],
    totalCourses: undefined,
    totalWithSchedules: undefined,
    schedules: [],
    meetingDateRanges: [],
  };
}

export const SchedulesData: MessageFns<SchedulesData> = {
  encode(message: SchedulesData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.termId !== 0) {
      writer.uint32(8).uint32(message.termId);
    }
    for (const v of message.courseCodes) {
      writer.uint32(18).string(v!);
    }
    if (message.totalCourses !== undefined) {
      writer.uint32(24).uint32(message.totalCourses);
    }
    if (message.totalWithSchedules !== undefined) {
      writer.uint32(32).uint32(message.totalWithSchedules);
    }
    for (const v of message.schedules) {
      CourseSchedule.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.meetingDateRanges) {
      MeetingDateRange.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchedulesData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchedulesData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.termId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.courseCodes.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalCourses = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.totalWithSchedules = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.schedules.push(CourseSchedule.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.meetingDateRanges.push(MeetingDateRange.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseGradesData(): GradesData {
  return { courses: [], sectionNames: [] };
}

export const GradesData: MessageFns<GradesData> = {
  encode(message: GradesData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.courses) {
      CourseGradeEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.sectionNames) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GradesData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGradesData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.courses.push(CourseGradeEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sectionNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseCourseGradeEntry(): CourseGradeEntry {
  return { code: "", nameRefs: [], termIds: [], professorRefs: [], legacyIds: [], sections: [], distributions: [] };
}

export const CourseGradeEntry: MessageFns<CourseGradeEntry> = {
  encode(message: CourseGradeEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    writer.uint32(18).fork();
    for (const v of message.nameRefs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.termIds) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.professorRefs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.legacyIds) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.sections) {
      writer.uint32(50).string(v!);
    }
    writer.uint32(58).fork();
    for (const v of message.distributions) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CourseGradeEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCourseGradeEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.nameRefs.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.nameRefs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 24) {
            message.termIds.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.termIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 32) {
            message.professorRefs.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.professorRefs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 40) {
            message.legacyIds.push(reader.uint32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.legacyIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sections.push(reader.string());
          continue;
        }
        case 7: {
          if (tag === 56) {
            message.distributions.push(reader.uint32());

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.distributions.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
}
